<section>

  <div class="container-one">
    <div class=" curve top-left-curve"></div>

    <div class="content">
      <h3>Welcome!</h3>

      <p>Streamlining school management for a brighter future.</p>

      <img src="/auth/teacher-student.png" alt="teacher teaching student">
    </div>

    <div class=" curve bottom-right-curve"></div>
  </div>

  <div class="container-two">
    <img class="school-logo" src="/auth/graduate.svg" alt="">

    <h3>Add a user</h3>

    <form #signupForm="ngForm" (ngSubmit)="signup(signupForm)">
      <div>
        <label for="query">Search School</label>
        <input (input)="getSchools(query)" [(ngModel)]="query" type="search" name="query" id="query" placeholder="Search for a school...">

        @if (schools()?.payload?.length && query !== '') {
          <ul>

            @for(s of schools()?.payload; track s.id) {
              <li (click)="selectSchool(s)">
                <h6>{{ s.school_name }}</h6>
                <p>School ID: {{s.public_id}}</p>
              </li>
            }

          </ul>
        }
      </div>

      @if(schoolPublicId){
        <div class="school-card">
          <div class="heading">
            <svg fill="#fff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>school</title> <path d="M30 21.25h-6.25v-8.957l5.877 3.358c0.107 0.062 0.236 0.098 0.373 0.099h0c0.414-0.001 0.749-0.336 0.749-0.751 0-0.277-0.15-0.519-0.373-0.649l-0.004-0.002-13.623-7.784v-0.552c0.172 0.016 0.35 0.068 0.519 0.068 0.004 0 0.010 0 0.015 0 0.475 0 0.934-0.067 1.368-0.193l-0.035 0.009c0.323-0.063 0.693-0.099 1.073-0.099 0.392 0 0.775 0.039 1.146 0.112l-0.037-0.006c0.039 0.007 0.083 0.012 0.129 0.012 0.184 0 0.352-0.068 0.479-0.181l-0.001 0.001c0.161-0.139 0.263-0.343 0.264-0.571v-2.812c0 0 0-0 0-0 0-0.355-0.247-0.653-0.579-0.73l-0.005-0.001c-0.419-0.111-0.9-0.176-1.396-0.176-0.5 0-0.985 0.065-1.446 0.187l0.039-0.009c-0.288 0.067-0.618 0.105-0.958 0.105-0.231 0-0.457-0.018-0.678-0.052l0.025 0.003c-0.122-0.256-0.378-0.43-0.676-0.43-0.412 0-0.746 0.334-0.746 0.746 0 0.001 0 0.003 0 0.004v-0 4.565l-13.622 7.784c-0.227 0.132-0.378 0.374-0.378 0.651 0 0.414 0.336 0.75 0.75 0.75 0.137 0 0.265-0.037 0.376-0.101l-0.004 0.002 5.878-3.359v8.957h-6.25c-0.414 0-0.75 0.336-0.75 0.75v0 8c0 0.414 0.336 0.75 0.75 0.75h28c0.414-0 0.75-0.336 0.75-0.75v0-8c-0-0.414-0.336-0.75-0.75-0.75v0zM18.658 3.075c0.298-0.082 0.64-0.13 0.993-0.13 0.183 0 0.363 0.013 0.539 0.037l-0.020-0.002v1.339c-0.16-0.013-0.345-0.021-0.533-0.021-0.489 0-0.966 0.052-1.425 0.151l0.044-0.008c-0.304 0.088-0.653 0.139-1.014 0.139-0.174 0-0.344-0.012-0.512-0.034l0.020 0.002v-1.323c0.15 0.014 0.325 0.021 0.502 0.021 0.499 0 0.984-0.062 1.447-0.18l-0.041 0.009zM2.75 22.75h5.5v6.5h-5.5zM9.75 22v-10.564l6.25-3.571 6.25 3.572v17.814h-2.5v-5.25c-0-0.414-0.336-0.75-0.75-0.75h-6c-0.414 0-0.75 0.336-0.75 0.75v0 5.25h-2.5zM13.75 29.25v-4.5h4.5v4.5zM29.25 29.25h-5.5v-6.5h5.5zM16 19.75c2.071 0 3.75-1.679 3.75-3.75s-1.679-3.75-3.75-3.75c-2.071 0-3.75 1.679-3.75 3.75v0c0.002 2.070 1.68 3.748 3.75 3.75h0zM16 13.75c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25c-1.243 0-2.25-1.007-2.25-2.25v0c0.002-1.242 1.008-2.248 2.25-2.25h0z"></path> </g></svg>
            <h4>Selected School</h4>
          </div>

          <div class="school-content">
            <p>SCHOOL NAME</p>
            <p>SCHOOL ID</p>

            <h5>{{schoolName}}</h5>
            <h5>{{schoolPublicId}}</h5>
          </div>
        </div>
      }

      <div>
        <label for="firstName">First Name</label>
        <input required [(ngModel)]="firstName" type="text" name="firstName" id="firstName" placeholder="e.g. Elorm">
      </div>

      <div>
        <label for="lastName">Last Name</label>
        <input required [(ngModel)]="lastName" type="text" name="lastName" id="lastName" placeholder="e.g. Attoh">
      </div>

      <div>
        <label for="username">Username</label>
        <input [disabled]="!schoolId || schoolId === ''" (input)="getUsers(username)" required [(ngModel)]="username" type="text" name="username" id="username" placeholder="e.g. eattoh25">

        @if (!this.users()?.payload?.length && username.length > 3) {
          <small>username is available</small>
        }

        @if (this.users()?.payload?.length && username.length > 3) {
          <small class="unavailable">username is unavailable</small>
        }
      </div>

      <div>
        <label for="temporaryPassword">Temporary password</label>
        <input required [(ngModel)]="temporaryPassword" [type]="showPassword ? 'text' : 'password'" name="temporaryPassword" id="temporaryPassword" placeholder="Enter a temporary password...">

        <button type="button" class="toggle-password" (click)="showPassword = !showPassword">
          @if (!showPassword) {
            <img src="/auth/eye-icon.svg" alt="eye icon">
          } @else {
            <img src="/auth/eye-slash.svg" alt="eye slash icon">
          }
        </button>
      </div>

      <div>
        <label for="role">Role</label>
        <select required [(ngModel)]="role" name="role" id="role">
          <option value="" hidden="">Select a role</option>
          <option value="TEACHER">Teacher</option>
          <option value="FINANCE_ADMIN">Finance Admin</option>
          <option value="SCHOOL_ADMIN">School Admin</option>
        </select>
      </div>


      <div>
        <button class="button" type="submit" [disabled]="signupForm.invalid || (temporaryPassword.length < 8)">
          @if (isLoading()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Add User
          }
        </button>
      </div>
    </form>

  </div>
</section>


